import { render, staticRenderFns } from "./task-project.vue?vue&type=template&id=3e623155&"
import script from "./task-project.vue?vue&type=script&lang=js&"
export * from "./task-project.vue?vue&type=script&lang=js&"
import style0 from "./task-project.vue?vue&type=style&index=0&id=3e623155&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports